import { useVHTypeConfig } from '@vh/components/vh-types/vhTypeHooks';
import { evaluationsSelector } from '@vh/slices/EvaluationSlice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useShownMenuSessionGoals = () => {
  const vhTypeConfig = useVHTypeConfig();
  const evaluations = useSelector(evaluationsSelector);
  const shownGoals = useMemo(() => {
    if (vhTypeConfig.usesEvaluations && evaluations.length > 0) {
      return evaluations.map((evaluation) => ({
        id: 'eval_' + evaluation.id,
        text: evaluation.name,
      }));
    }
    // else if (vhTypeConfig.usesObjectives && objectives.length > 0){

    // }
    return [];
  }, [evaluations, vhTypeConfig.usesEvaluations]);

  return shownGoals;
};
